import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  FinalCta,
  FreeWeek,
  Guide,
  Hero,
  Programs,
  Reasons,
  WhatIsJen,
} from './sections';
import './style.css';

/**
 * Free Trial landing page body (everything between the site header and footer).
 * `onStart(sectionTitle)` runs the guest auth flow; signed-in users go straight
 * to checkout for the selected plan (see `useTrialCta`).
 */
const FreeTrialLanding = ({ loading = false, onStart }) => {
  useEffect(() => {
    const app = document.getElementById('app');
    app?.classList.add('payment-page-active');
    return () => app?.classList.remove('payment-page-active');
  }, []);

  return (
    <div className="ftl">
      <Hero onStart={onStart} loading={loading} />
      <WhatIsJen />
      <FreeWeek onStart={onStart} loading={loading} />
      <Reasons />
      <Programs onStart={onStart} loading={loading} />
      <Guide />
      <FinalCta onStart={onStart} loading={loading} />
    </div>
  );
};

FreeTrialLanding.propTypes = {
  loading: PropTypes.bool,
  onStart: PropTypes.func.isRequired,
};

export default FreeTrialLanding;
